function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { DropdownIconContainer, InputContent, SelectContainer } from './components/styles';
import { Icon, ThemingContext } from '@doordash/design-language';
import FieldWrapper from './components/FieldWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import groupBy from 'lodash.groupby';
import omit from 'lodash.omit';
var OPTIONS_SHAPE = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  group: PropTypes.string
})); // These have to be functions because older versions of React
// don't allow arrays to be returned in render methods
// for use in JSX.

var renderOptions = function renderOptions(_ref) {
  var options = _ref.options;
  return options.map(function (option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.name);
  });
};

renderOptions.PropTypes = {
  options: OPTIONS_SHAPE // See note above about why this is a function and not
  // a component used in JSX.

};

var groupOptions = function groupOptions(_ref2) {
  var options = _ref2.options;
  var groupedOptions = groupBy(options, 'group');
  var groups = Object.keys(groupedOptions); // If there are multiple groups, render optgroups

  if (groups.length > 1) {
    return Object.entries(groupedOptions).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          group = _ref4[0],
          groupsOptions = _ref4[1];

      // Group all named groups
      if (group !== 'undefined') {
        return React.createElement("optgroup", {
          label: group,
          key: group
        }, renderOptions({
          options: groupsOptions
        }));
      } // If group isn't set on the option ('undefined'),
      // render the options directly


      return renderOptions({
        options: groupsOptions
      });
    });
  }

  return renderOptions({
    options: options
  });
};

groupOptions.propTypes = {
  options: OPTIONS_SHAPE
  /**
   * https://developers.google.com/web/fundamentals/accessibility/semantics-aria/aria-labels-and-relationships
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html
   * https://developers.google.com/web/fundamentals/design-and-ui/input/forms/
   */

};

var SelectContent = function SelectContent(_ref5) {
  var id = _ref5.id,
      label = _ref5.label,
      innerRef = _ref5.innerRef,
      value = _ref5.value,
      _onChange = _ref5.onChange,
      isRequired = _ref5.isRequired,
      isDisabled = _ref5.isDisabled,
      isLabelHidden = _ref5.isLabelHidden,
      autoFocus = _ref5.autoFocus,
      onFocus = _ref5.onFocus,
      onBlur = _ref5.onBlur,
      placeholder = _ref5.placeholder,
      name = _ref5.name,
      disabledValue = _ref5.disabledValue,
      options = _ref5.options,
      size = _ref5.size;
  var theme = React.useContext(ThemingContext);
  return React.createElement(SelectContainer, null, React.createElement(InputContent, {
    theme: theme,
    id: id,
    innerRef: innerRef,
    tag: "select",
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value, event);
    } // Only one of `<label>` and `aria-label` should be implemented
    // Using two or more together (e.g., a hidden <label> and a
    // duplicate title attribute) can cause information to be
    // repeated by a screen reader.
    // http://webaim.org/techniques/forms/advanced#hiddenlabel
    ,
    "aria-label": isLabelHidden ? label : null,
    required: isRequired,
    disabled: isDisabled,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    name: name,
    inputSize: size
  }, disabledValue && React.createElement("option", {
    disabled: true,
    value: ""
  }, typeof disabledValue === 'string' ? disabledValue : ''), groupOptions({
    options: options
  })), React.createElement(DropdownIconContainer, null, React.createElement(Icon, {
    color: Icon.Colors.FieldsIconDropdown,
    type: Icon.Types.ChevronDown,
    size: Icon.Sizes.Medium
  })));
};

SelectContent.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  innerRef: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  isLabelHidden: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.string,
  name: PropTypes.string,
  renderBeforeContent: PropTypes.func,
  renderAfterContent: PropTypes.func,
  disabledValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  options: OPTIONS_SHAPE,
  size: FieldWrapper.propTypes.size
};

var Select = function Select(_ref6) {
  var autoFocus = _ref6.autoFocus,
      isDisabled = _ref6.isDisabled,
      onFocus = _ref6.onFocus,
      onBlur = _ref6.onBlur,
      onChange = _ref6.onChange,
      value = _ref6.value,
      label = _ref6.label,
      isLabelHidden = _ref6.isLabelHidden,
      isRequired = _ref6.isRequired,
      isRounded = _ref6.isRounded,
      error = _ref6.error,
      description = _ref6.description,
      placeholder = _ref6.placeholder,
      renderBeforeContent = _ref6.renderBeforeContent,
      renderAfterContent = _ref6.renderAfterContent,
      renderConnectedBefore = _ref6.renderConnectedBefore,
      renderConnectedAfter = _ref6.renderConnectedAfter,
      name = _ref6.name,
      options = _ref6.options,
      disabledValue = _ref6.disabledValue,
      size = _ref6.size;
  return React.createElement(FieldWrapper, {
    label: label,
    description: description,
    error: error,
    isDisabled: isDisabled,
    isLabelHidden: isLabelHidden,
    isRounded: isRounded,
    renderBeforeContent: renderBeforeContent,
    renderAfterContent: renderAfterContent,
    renderConnectedBefore: renderConnectedBefore,
    renderConnectedAfter: renderConnectedAfter,
    size: size
  }, React.createElement(SelectContent, {
    label: label,
    autoFocus: autoFocus,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange,
    value: value,
    name: name,
    isDisabled: isDisabled,
    isLabelHidden: isLabelHidden,
    isRequired: isRequired,
    placeholder: placeholder,
    options: options,
    disabledValue: disabledValue,
    size: size
  }));
};

Select.Sizes = FieldWrapper.Sizes;
Select.propTypes = _objectSpread({}, omit(FieldWrapper.propTypes, ['children']), SelectContent.propTypes);
Select.defaultProps = {
  size: Select.Sizes.Medium
};
export default Select;